<layout-sidebar>
  <div class="replace-vehicle-review main">
    <ds-error-message [errorList]="errorList"></ds-error-message>
    <div class="row margin-bottom-10">
      <div class="column twelve">
        <h4 class="heading-sub-section">New Vehicle Quote</h4>
        @if (newVehicle) {
          <p class="new-vehicle"><span class="icon-auto pad-right-10"></span> {{ newVehicle }}</p>
        }
      </div>
    </div>

    @if (roleService.isAuthorized('replacevehiclequote_view') | async) {
      <div class="row margin-bottom-20">
        <div class="column twelve">
          <ds-premium-details [quotes]="premiumDetails"></ds-premium-details>
        </div>
      </div>
    }

    <div class="row pad-bottom-20 flex">
      <span class="control-label pad-right-10"></span>
      <span
        dsContent
        [contentPath]="'policy.replaceVehicleQuoteInfoTextOnlineBind'"
        [options]="{
          currentVehicle: currentVehicle
        }"
        class="column twelve items-center"
      >
      </span>
    </div>

    <div class="row">
      <div class="column twelve">
        <blockquote class="border -primary-600">
          <p dsContent [contentPath]="'policy.replaceVehicletermsText'"></p>
        </blockquote>
      </div>
    </div>

    <div class="row">
      <div class="row">
        <div class="column twelve">
          <a
            class="inline-block margin-top-20 caption"
            href="javascript:void(0)"
            (click)="getAnotherQuoteClick()"
            >Get Another Quote</a
          >
          <button
            ds-button
            class="secondary-cta -outline-white float-right -offset-top"
            type="button"
            [disabled]="!(roleService.isAuthorized('replacevehiclequote_sendtoagent') | async)"
            (click)="submit()"
          >
            Send to my agent
          </button>

          <button
            ds-button
            class="secondary-cta -outline md-float-right md-margin-right-20 -offset-top"
            type="button"
            (click)="submitOnlineBind()"
            data-cy="replaceVehicleSubmitBindButton"
          >
            Replace vehicle now
          </button>
        </div>
      </div>
    </div>
  </div>
  <aside class="main-aside">
    <links-agents-sidebar></links-agents-sidebar>
  </aside>
</layout-sidebar>
